import React from "react";
import PropTypes from "prop-types";

import Input from "./Input/Input.base";

const SpeechInfo = ({
  onTitleChange,
  titleValue,
  onDescriptionChange,
  descriptionValue
}) => (
  <form style={{ marginTop: "100px" }}>
    <h2>Renseigne un Titre et une courte description avant d'appuyer sur DEMARRER en bas de l'écran.</h2>
    <p>
      Si l'enregistrement ne fonctionne pas, vérifie que ta webcam est bien allumée et autorise ton navigateur 
      à accéder à ta webcam, micro et débloque la lecture automatique.
    </p>
    <Input
      type="text"
      label="Titre"
      name="pitchTitle"
      maxLength="40"
      value={titleValue}
      onChange={onTitleChange}
    />
    <Input
      type="text"
      label="Description"
      name="pitchDescription"
      maxLength="140"
      value={descriptionValue}
      onChange={onDescriptionChange}
      multiline
      rowsMax={3}
    />
  </form>
);

SpeechInfo.propTypes = {
  onTitleChange: PropTypes.func.isRequired,
  onDescriptionChange: PropTypes.func.isRequired,
  titleValue: PropTypes.string.isRequired,
  descriptionValue: PropTypes.string.isRequired
};

export default SpeechInfo;
